import React from "react";
import Icon from "./Icon";

const PAGE_SIZES = [10, 25, 50, 100];

interface Props {
  page: number;
  pageSize: number;
  total: number;
  shownCount: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

const Pager: React.FC<Props> = ({
  page,
  pageSize,
  total,
  shownCount,
  onPageChange,
  onPageSizeChange,
}) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(page, totalPages);
  const startIdx = (safePage - 1) * pageSize;

  return (
    <div className="pagination">
      <div className="pagination-info">
        Showing{" "}
        <strong>
          {startIdx + 1}–{startIdx + shownCount}
        </strong>{" "}
        of <strong>{total}</strong>
      </div>
      <div className="pagination-controls">
        <label className="pagination-size">
          Rows per page
          <select
            className="select"
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
            style={{ width: 76, height: 32 }}
          >
            {PAGE_SIZES.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </label>
        <div className="pagination-nav">
          <button
            className="page-btn"
            disabled={safePage === 1}
            onClick={() => onPageChange(1)}
            title="First page"
          >
            <Icon name="chevron-left" size={13} />
            <Icon name="chevron-left" size={13} style={{ marginLeft: -8 }} />
          </button>
          <button
            className="page-btn"
            disabled={safePage === 1}
            onClick={() => onPageChange(Math.max(1, safePage - 1))}
            title="Previous"
          >
            <Icon name="chevron-left" size={14} />
          </button>
          <span className="page-indicator">
            Page <strong>{safePage}</strong> of {totalPages}
          </span>
          <button
            className="page-btn"
            disabled={safePage === totalPages}
            onClick={() => onPageChange(Math.min(totalPages, safePage + 1))}
            title="Next"
          >
            <Icon name="chevron-right" size={14} />
          </button>
          <button
            className="page-btn"
            disabled={safePage === totalPages}
            onClick={() => onPageChange(totalPages)}
            title="Last page"
          >
            <Icon name="chevron-right" size={13} />
            <Icon name="chevron-right" size={13} style={{ marginLeft: -8 }} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pager;
